import {
  ProcessorScheduling,
  ProcessorSettingsKillAndChillSettings,
} from './graphql';

export function isKillAndChillAvailable(
  killAndChillSettings: ProcessorSettingsKillAndChillSettings[] | undefined,
  animalSpecie: string | undefined,
) {
  if (!killAndChillSettings?.length || !animalSpecie) {
    return false;
  }

  return !!killAndChillSettings.find(
    (setting) => setting.isEnabled && setting.species === animalSpecie,
  );
}

export function isKillAndChill(scheduling: ProcessorScheduling | undefined) {
  return scheduling?.animalHeads?.some((head) => head?.isKillAndChill);
}
